import {
  Box,
  Text,
  Link,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  List,
  ListItem,
  Image,
  Center,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import React, { useState, useEffect, useCallback } from "react";
import BaseLayout from "../../../components/base_layout";

export default function BrandInfo() {
  const router = useRouter();
  const code = router.query.code;

  useEffect(() => {
    //code
  }, []);

  return (
    <BaseLayout>
      <Box className="brand-main flex-center">
        <Box>
          <Text fontSize="10px" textAlign="center">
            홈 {">"} PulseLarsen ELECTRONICS(PulseLarsen ELECTRONICS)
          </Text>
          <Box className="brand__img flex-center">
            <Image src="https://www.pulselarsenantennas.com/wp-content/uploads/2019/02/PulseNewLogo-300x114.png" />
          </Box>
        </Box>
        <Box className="brand-info-container">
          <Box className="brand-info-container__title" fontSize="15px">
            <Text>PulseLarsen ELECTRONICS</Text>
            <Text>|</Text>
            <Text color="#858796">PulseLarsen ELECTRONICS</Text>
          </Box>
          <Text fontSize="12px">
            Pulse Electronics는 필요한 기술 솔루션을 제공하여 고객이 차세대
            제품을 구축 할 수 있도록 도와주는 전자 부품의 선도적 인 공급
            업체입니다. Larsen 브랜드의 안테나를 포함한 Pulse Electronics는
            안테나, 자기 및 커넥터 분야에서 오랜 혁신의 역사를 가지고있을뿐만
            아니라 고품질의 대량 생산에 신속하게 진입 할 수있는 능력을 가지고
            있습니다. 회사는 무선 및 유선 통신, 전력 관리, 군사 / 항공 우주 및
            자동차 산업에 서비스를 제공합니다.
          </Text>
        </Box>
      </Box>
    </BaseLayout>
  );
}
